/** 断网时向用户展示的文案 */
export const OFFLINE_TOAST_MESSAGE =
    'Sin conexión a Internet. verifica tu conexión.';

/**
 * 监听断网：进入页面时已离线会提示；之后 `offline` 事件再提示。
 * @returns 取消监听的函数，应在 `onDestroy` 中调用。
 */
export function attachOfflineToast(show: (message: string) => void): () => void {
    const onOffline = () => show(OFFLINE_TOAST_MESSAGE);

    window.addEventListener('offline', onOffline);

    if (!navigator.onLine) {
        queueMicrotask(() => show(OFFLINE_TOAST_MESSAGE));
    }

    return () => {
        window.removeEventListener('offline', onOffline);
    };
}
